// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_da-2";
export var aiChatCartContainerExit = "_da-4";
export var aiChatContainerLarge = "_da-0";
export var aiChatContainerSmall = "_da-1";
export var aiChatIcon = "_da-6";
export var slideInFromRight = "_da-3";
export var slideOutToRight = "_da-5";